export default [
  {
    title: "Heartbeat",
    source: "Heartbeat",
    uri: require("../assets/Heartbeat.mp3"),
    iconType: "fontawesome",
    iconNot: 'heart-pulse',
    iconPlaying: 'heart-pulse',
    iconPlayingColor: "red",
  },
  {
    title: "Heartbeat 2",
    source: "Heartbeat2",
    uri: require("../assets/heartbeat2.m4a"),
    iconType: "fontawesome",
    iconNot: "heart",
    iconPlaying: "heart",
    iconPlayingColor: "red",
  },
  {
    title: "Tom",
    source: "Tom",
    uri: require("../assets/tom.m4a"),
    iconType: "fontawesome",
    iconNot: "drum",
    iconPlaying: "drum",
    iconPlayingColor: "orange",
  },
  {
    title: "Synth Drum",
    source: "Bassdrum",
    uri: require("../assets/synthdrum.m4a"),
    iconType: "fontawesome",
    iconNot: "drum-steelpan",
    iconPlaying: "drum-steelpan",
    iconPlayingColor: "purple",
  },
  {
    title: "Deep Drum",
    source: "Deepdrum",
    uri: require("../assets/deepdrum.m4a"),
    iconType: "fontawesome",
    iconNot: "drum",
    iconPlaying: "drum",
    iconPlayingColor: "brown",
  },
  {
    title: "Tick",
    source: "Tick",
    uri: require("../assets/tick_1.m4a"),
    iconType: "fontawesome",
    iconNot: "clock",
    iconPlaying: "clock",
    iconPlayingColor: "#CD7F32",
  },
  {
    title: "Tick Tock",
    source: "TickTock",
    uri: require("../assets/tick_2.m4a"),
    alternateSound: require("../assets/tick_1.m4a"),
    iconType: "fontawesome",
    iconNot: "clock",
    iconPlaying: "clock",
    iconPlayingColor: "#B8860B",
  },
  {
    title: "Impact",
    source: "Impact",
    uri: require("../assets/impact.m4a"),
    iconType: "fontawesome",
    iconNot: "bolt",
    iconPlaying: "bolt",
    iconPlayingColor: "yellow",
  },
  {
    title: "Throb",
    source: "Throb",
    uri: require("../assets/throb.m4a"),
    iconType: "fontawesome",
    iconNot: "wave-square",
    iconPlaying: "wave-square",
    iconPlayingColor: "red",
  },
  {
    title: "Whoosh",
    source: "Whoosh",
    uri: require("../assets/whoosh.m4a"),
    iconType: "fontawesome",
    iconNot: "wind",
    iconPlaying: "wind",
    iconPlayingColor: "blue",
  },
  {
    title: "Cricket",
    source: "Cricket",
    uri: require("../assets/cricket.m4a"),
    iconType: "fontawesome",
    iconNot: "locust",
    iconPlaying: "locust",
    iconPlayingColor: "green",
  },
  {
    title: "Frog",
    source: "Frog",
    uri: require("../assets/frog.m4a"),
    iconType: "fontawesome",
    iconNot: "frog",
    iconPlaying: "frog",
    iconPlayingColor: "green",
  },
    {
    title: "Heartrate monitor",
    source: "Monitor",
    uri: require("../assets/HeartMonitor.m4a"),
    iconType: "image",
    // imageNot: "../assets/monitor.png",
    // imagePlay: "../assets/monitor_reverse.png",
    iconNot: 'heart-pulse',
    iconPlaying: 'heart-pulse',
    iconPlayingColor: "green",
  },
];
